
<template>
<div>
  <chc-input v-model="name" label="Proceeds Rate ID Name" :required="true"></chc-input>
    <div>
      <div class="towing-tier">
        <span>{{ bottom_tier.bottom }}</span>
        <span> to </span>
        <chc-input v-model="bottom_tier.top" label="Number"></chc-input>
        <span> Vehicles per month </span>
        <chc-input v-model="bottom_tier.rate" label="Proceeds Rate" format="percent"></chc-input>
        <span> &percnt; </span>
      </div>
      <div class="towing-tier" v-for="(rate, index) in additional_tiers" :key="index">
        <chc-input v-model="rate.bottom" label="Number"></chc-input>
        <span> to </span>
        <chc-input v-model="rate.top" label="Number"></chc-input>
        <span> Vehicles per month </span>
        <chc-input v-model="rate.rate" label="Proceeds Rate" format="percent"></chc-input>
        <span> &percnt; </span>
        <span> <a @click="removeProceedsTier(index)"> Delete </a> </span>
      </div>
      <div class="add-tier field">
        <a v-on:click="addProceedsTier">+ Add Another Tier</a>
      </div>
      <div class="towing-tier">
        <chc-input v-model="top_tier.bottom" label="Number"></chc-input>
        <span> to </span>
        <span>{{ top_tier.top }}</span>
        <span> Vehicles per month </span>
        <chc-input v-model="top_tier.rate" label="Proceeds Rate" format="percent"></chc-input>
        <span> &percnt; </span>
      </div>
    </div>
    <div class="field buttons left">
      <input type="submit" class="btn" value="Add Tiered Proceeds Rate" @click="submit">
    </div>
</div>
</template>

<script>
import store from '@/store'

export default {
  name: 'CharityProceedsRateTiers',
  props: [],
  data () {
    return {
      name: null,
      bottom_tier: {
        bottom: 0,
        top: null,
        rate: null
      },
      top_tier: {
        bottom: null,
        top: 'Unlimited',
        rate: null
      },

      additional_tiers: [],
    }
  },
  computed: {
    allTiers () {
      let tiers = []
      tiers.push(this.bottom_tier)
      for (var i = 0; i <= this.additional_tiers.length - 1; i++) {
        tiers.push(this.additional_tiers[i])
      }
      tiers.push(this.top_tier)
      return tiers
    }
  },
  methods: {
    addProceedsTier () {
      this.additional_tiers.push({
        bottom: null,
        top: null,
        rate: null
      })
    },
    removeProceedsTier (index) {
      this.additional_tiers.splice(index, 1)
    },
    submit () {
      store.functions.tieredProceedsRate.createTieredProccedsRate(
        {
          name: this.name,
          tiers: this.allTiers,
        },
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        }).then((response) => {
        this.hasErrors = false
        this.$emit('refresh', {'tier': response.data})
        this.$emit('close')
      })
    },
  }
}
</script>

<style lang="scss" scoped>

/* NEW TOWING COMPANY */
.towing-tier {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  .field {
    margin: 0 0 1rem 0;
    width: 100px;
    &:last-of-type {
      width: 150px;
    }
  }
}
.towing-tier span {
    padding-left: 1em;
    padding-right: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityProceedsRateTiers.vue